<template>
  <button
    class="btn btn-primary width--100per t-600 mb-2 box-shadow"
    v-if="showEmailButton"
    v-tooltip="formatTooltipMessage"
    type="button"
    @click.prevent="clickButton"
  >
    <i class="fa fa-envelope t-white t-xs pr-2" />Send Email
  </button>
</template>

<script>

export default {
  name: 'profileSendEmail',
  props: {
    scope: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    contacts: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    formatTooltipMessage: function () {
      return 'Write an email to ' + (this.contacts.length > 1 ? 'one of the contacts in this group' : this.getFullName(this.contacts[0]))
    },
    showEmailButton () {
      if (this.canEdit || this.isEmpty(this.contacts)) {
        return false
      }
      if (this.scope === 'researchers') {
        return this.contacts[0].email
      } else {
        return true
      }
    },
    isPublicView () {
      return this.$can.getAsPublic()
    }
  },
  methods: {
    clickButton () {
      if (this.isPublicView) return
      this.$events.$emit('modal:contact:mail:create', this.contacts, this.item.phone, this.scope, this.item.slug_values[0], this.item.name)
    }
  }
}
</script>
